import React from 'react';
import { motion } from 'framer-motion';
import { FiArrowDownRight } from 'react-icons/fi';
import { portfolioData } from '../../data/portfolioData';
import k8sLogo from '../../utils/kubernetes-logo.svg';

const line = {
  hidden: { y: '110%' },
  visible: (i) => ({
    y: '0%',
    transition: { duration: 1, ease: [0.16, 1, 0.3, 1], delay: 0.2 + i * 0.12 },
  }),
};

const fade = {
  hidden: { opacity: 0, y: 24 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.6 + i * 0.1 },
  }),
};

function Terminal() {
  const { prompt, lines } = portfolioData.terminal;
  return (
    <motion.div
      className="terminal"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: 0.9 }}
    >
      <div className="terminal-bar">
        <span className="tdot r" />
        <span className="tdot y" />
        <span className="tdot g" />
        <span className="title">{prompt}:~</span>
      </div>
      <div className="terminal-body">
        {lines.map((l, i) =>
          l.cmd ? (
            <div className="cmd" key={i}>
              {l.cmd}
            </div>
          ) : (
            <div className={`out ${l.out.includes('complete') ? 'ok' : ''}`} key={i}>
              {l.out}
            </div>
          )
        )}
        <div className="cmd">
          <span className="terminal-caret" />
        </div>
      </div>
    </motion.div>
  );
}

export default function Hero() {
  const { firstName, lastName, role, tagline, description, location, availability } =
    portfolioData.hero;

  return (
    <header className="hero" id="top">
      <div className="hero-copy">
        <motion.div className="hero-meta" initial="hidden" animate="visible">
          <motion.span custom={0} variants={fade} className="live">
            <span className="pulse" /> {availability}
          </motion.span>
          <motion.span custom={1} variants={fade}>
            {location}
          </motion.span>
          <motion.span custom={2} variants={fade}>
            . 2000
          </motion.span>
        </motion.div>

        <h1 className="hero-title" aria-label={`${firstName} ${lastName}`}>
          <span className="line">
            <motion.span custom={0} variants={line} initial="hidden" animate="visible">
              {firstName}
            </motion.span>
          </span>
          <span className="line">
            <motion.span
              custom={1}
              variants={line}
              initial="hidden"
              animate="visible"
              className="outline-text"
            >
              {lastName}
            </motion.span>
          </span>
        </h1>

        <motion.div className="hero-role" initial="hidden" animate="visible">
          <motion.span custom={2} variants={fade}>
            {role}
          </motion.span>
          <motion.span custom={3} variants={fade} className="sep">
            //
          </motion.span>
          <motion.span custom={4} variants={fade} className="cyan-text">
            {tagline}
          </motion.span>
        </motion.div>

        <motion.p className="hero-desc" custom={5} variants={fade} initial="hidden" animate="visible">
          {description}
        </motion.p>

        <motion.div
          className="hero-cta"
          custom={6}
          variants={fade}
          initial="hidden"
          animate="visible"
        >
          <a href="#contact" className="btn btn-primary interactive">
            Let's build something <FiArrowDownRight />
          </a>
          <a href="#work" className="btn btn-ghost interactive">
            View work
          </a>
        </motion.div>
      </div>

      <div className="hero-visual">
        <div className="k8s-badge">
          <img src={k8sLogo} alt="Kubernetes" />
        </div>
        <Terminal />
      </div>
    </header>
  );
}
